import React, {useState, useRef} from "react";
import "./App.scss";

// components
import Filter from "./components/Filter";
import Image from "./components/Image";
import Updown from "./components/Updown";

function App() {
  const ref = useRef(null);
  const [image, setImage] = useState(null);
  const [filters, setFilters] = useState({
    blur: 0,
    brightness: 100,
    contrast: 100,
    grayscale: 0,
    hueRotate: 0,
    invert: 0,
    opacity: 100,
    seturate: 100,
    sepia: 0,
    leftRight: false,
})
  return (
    <div className="content">
      <div className="filters">
        <Filter refHook={ref} filters={filters} setFilters={setFilters} Image={image}/>
      </div>
      <div className="image-button">
        <Updown upload={setImage} image={image}/>
        <Image refHook={ref} image={image} filters={filters}/>
      </div>
    </div>
  );
}

export default App;
